import { render, staticRenderFns } from "./ApplicationsF-biotic.vue?vue&type=template&id=6848fad2&scoped=true&"
import script from "./ApplicationsF-biotic.vue?vue&type=script&lang=js&"
export * from "./ApplicationsF-biotic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848fad2",
  null
  
)

export default component.exports